import { h, Fragment } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Pagination = props => {
  const pages = []
  const length = Math.ceil(props.totalAmountPosts / props.count + 1)

  for (let i = 1; i < length; i++) {
    pages.push(i)
  }

  if (pages.length > 1) {
    return (
      <div className="c-shop-pagination">
        <div className="c-shop-pagination__container">
          <Pages
            pages={pages}
            currentPage={props.currentPage}
            handlePageClick={props.handlePageClick}
          />
        </div>
      </div>
    )
  }
}

const Pages = props => {
  const max = props.currentPage == 1 ? 3 : Number(props.currentPage) + 1
  const min =
    props.currentPage == props.pages.length
      ? props.pages.length - 3
      : Number(props.currentPage) - 2

  // Function to check what pages should show in the pagination
  return (
    <div class="c-shop-overview__fragment-wrapper">
      {props.currentPage > 2 && props.pages.length > 3 ? (
        <div class="c-shop-overview__fragment-wrapper">
          <div
            data-page={Number(props.currentPage - 1)}
            className="c-shop-pagination__button c-shop-pagination__button--prev"
            onClick={props.handlePageClick}
          >
            <svg className="c-icon c-shop-pagination__icon">
              <use href="#chevron-right" xlinkHref="#chevron-right" />
            </svg>
          </div>
          <Page
            handlePageClick={props.handlePageClick}
            page={props.pages[0]}
            currentPage={props.currentPage}
          />
        </div>
      ) : null}
      {props.pages.map((page, index) => {
        if (index < max && index + 1 > min) {
          return (
            <Page
              handlePageClick={props.handlePageClick}
              page={page}
              currentPage={props.currentPage}
            />
          )
        }
      })}
      {props.currentPage < props.pages.length - 1 && props.pages.length > 3 ? (
        <div class="c-shop-overview__fragment-wrapper">
          <Page
            handlePageClick={props.handlePageClick}
            page={props.pages[props.pages.length - 1]}
            currentPage={props.currentPage}
          />
          <div
            data-page={props.currentPage + 1}
            className="c-shop-pagination__button c-shop-pagination__button--next"
            onClick={props.handlePageClick}
          >
            <svg className="c-icon c-shop-pagination__icon">
              <use href="#chevron-right" xlinkHref="#chevron-right" />
            </svg>
          </div>
        </div>
      ) : null}
    </div>
  )
}

const Page = props => (
  <div
    onClick={props.handlePageClick}
    className={`c-shop-pagination__page ${
      props.currentPage == props.page ? 'active' : ''
    }`}
    data-page={props.page}
    key={props.page}
  >
    {props.page}
  </div>
)

export default Pagination


// WEBPACK FOOTER //
// ./src/js/shop-overview/components/Pagination.js